module.exports = __webpack_public_path__ + "img/logo-la-cite.bc690679.jpg";